module.exports = __webpack_public_path__ + "img/LB.ed46bf04.png";